import { ImageMap } from "@qiuz/react-image-map";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SustainabilityImage = () => {
  const navigate = useNavigate()
  // Define map areas with unique IDs and hover state
  const [mapArea, setMapArea] = useState([
    {
      id: 1,
      desc: "1st area",
      left: "0%",
      top: "0%",
      height: "47%",
      width: "24%",
      color: "",
      hoveredColor: "",
      hovered: false,
    },
    {
      id: 2,
      desc: "2nd area",
      left: "0%",
      top: "50%",
      height: "47%",
      width: "24%",
      color: "",
      hoveredColor: "",
      hovered: false,
    },
    {
      id: 3,
      desc: "3rd area",
      left: "76%",
      top: "50%",
      height: "47%",
      width: "24%",
      color: "",
      hoveredColor: "",
      hovered: false,
    },
    {
      id: 4,
      desc: "4th area",
      left: "76%",
      top: "0%",
      height: "47%",
      width: "24%",
      color: "",
      hoveredColor: "",
      hovered: false,
    },
  ]);

  // Hover functions to set hover effect on area
  const handleMouseEnter = (index) => {
    setMapArea((prevAreas) =>
      prevAreas.map((area, i) =>
        i === index ? { ...area, hovered: true } : area
      )
    );
  };

  const handleMouseLeave = (index) => {
    setMapArea((prevAreas) =>
      prevAreas.map((area, i) =>
        i === index ? { ...area, hovered: false } : area
      )
    );
  };

  useEffect(()=>{
    setMapArea([
      {
        id: 1,
        desc: "1st area",
        left: "0%",
        top: "0%",
        height: "47%",
        width: "24%",
        color: "",
        hoveredColor: "",
        hovered: false,
      },
      {
        id: 2,
        desc: "2nd area",
        left: "0%",
        top: "50%",
        height: "47%",
        width: "24%",
        color: "",
        hoveredColor: "",
        hovered: false,
      },
      {
        id: 3,
        desc: "3rd area",
        left: "76%",
        top: "50%",
        height: "47%",
        width: "24%",
        color: "",
        hoveredColor: "",
        hovered: false,
      },
      {
        id: 4,
        desc: "4th area",
        left: "76%",
        top: "0%",
        height: "47%",
        width: "24%",
        color: "",
        hoveredColor: "",
        hovered: false,
      },
    ])
  },[])

  return (
      <ImageMap
        className="usage-map"
        width={"100%"}
        height={"78%"}
        src="/images/sustainability-screen2.png"
        map={mapArea.map((area, index) => ({
          ...area,
          onMouseEnter: () => handleMouseEnter(index),
          onMouseLeave: () => handleMouseLeave(index),
          style: {
            backgroundColor: area.hovered ? area.hoveredColor : area.color,
            cursor: "pointer", // Show pointer cursor on hover
          },
        }))}
        onMapClick={(area, index)=>{
          console.log("test index", index)
          if(index===0){
            navigate('/sustainability/employeesatisfaction')
          }else if(index === 1){
            navigate('/sustainability/environment')
          }else if(index === 2){
            navigate('/sustainability/carbon')
          }else if(index === 3){
            navigate('/sustainability/energy')
          }
            
        }}
      />
  );
};

export default SustainabilityImage;
